import { useMemo } from 'react';

interface Props {
    projectId: number;
    contractId: number;
    projectHierarchyList: IProjectHierarchyList[];
}

export const useGetProjectAndContractById = ({ projectId, contractId, projectHierarchyList }: Props) => {
    const foundProjectFromHierarchyList = useMemo(
        () => projectHierarchyList?.children.find((project) => project.id === projectId),
        [projectHierarchyList, projectId],
    );

    const foundContractFromHierarchyList = useMemo(
        () => foundProjectFromHierarchyList?.children.find((contract) => contract.id === contractId),
        [foundProjectFromHierarchyList, contractId],
    );

    return {
        project: foundProjectFromHierarchyList,
        contract: foundContractFromHierarchyList,
    };
};
